//dependencias
import React, { Component } from 'react';

//componentes
import AutorizarExpediente from './autorizarExpe'

class Index extends Component {

    render(){
        return(
            <div>
                <AutorizarExpediente />
            </div>
        );
    }

}
export default Index;